import MenuItem from 'material-ui/MenuItem';
import React, {Component} from 'react';
import SelectField from 'material-ui/SelectField';
import styled from 'styled-components';

import AddMetaModal from './AddMetaModal';

const style = {
  maxWidth: 500,
  width: '100%',
};

const AddButton = styled.span`
  color: ${props => props.theme.alternateColor};
  border: 1px solid ${props => props.theme.alternateColor};
  cursor: pointer;
  font-size: 22px;
  margin-left: 10px;
  line-height: 25px;
  height: 30px;
  width: 30px;
  text-align: center;
  box-sizing: border-box;

  &:hover {
    background-color: ${props => props.theme.alternateColor};
    color: #fff;
  }
`;

const Wrapper = styled.span`
  display: flex;
  align-items: center;
`;
class Select extends Component {
  state = {showAddModal: false};

  _handleChange = (event, index, value) => this.props.onChange({key: this.props.metaType, value});
  _openAddMetaModal = () => {
    this.setState({showAddModal: true});
  };
  _closeAddMetaModal = () => {
    this.setState({showAddModal: false});
  };
  render() {
    const {value, label, showAdd, metaType} = this.props;
    const {showAddModal} = this.state;
    return (
      <Wrapper>
        <SelectField
          floatingLabelText={label}
          floatingLabelFixed={true}
          value={value}
          onChange={this._handleChange}
          style={style}>
          <MenuItem key={`item_default_${metaType}`} value={null} primaryText={'Bitte wählen'} />
          {this.props.data.map((item, i) => (
            <MenuItem key={`item_${i}_${metaType}`} value={item._id} primaryText={item.value} />
          ))}
        </SelectField>
        {showAdd && <AddButton onClick={this._openAddMetaModal}>+</AddButton>}
        {showAddModal && (
          <AddMetaModal
            metaType={metaType}
            metaTypeLabel={label}
            open={showAddModal}
            onCancel={this._closeAddMetaModal}
            save={this._closeAddMetaModal}
          />
        )}
      </Wrapper>
    );
  }
}

export default Select;



// WEBPACK FOOTER //
// ./src/components/Select.js